var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.merchantSupportLinkddress || _vm.merchantSupportEmailAddress)?_c('a',{staticClass:"link link--margin",attrs:{"id":"help-link","href":_vm.href,"target":"_blank"}},[_vm._v(" Need help? ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }